// extracted by mini-css-extract-plugin
export default {"spanBlock":"SuperEditableSpan_spanBlock__+RmCY","span":"SuperEditableSpan_span__l-xvq","input":"SuperEditableSpan_input__5D5-c","pen":"SuperEditableSpan_pen__5FdR-"};